module.exports = __webpack_public_path__ + "static/img/yuanquan.0085709.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/platformIntroduce/yuanquan.png
// module id = bjqN
// module chunks = 70